import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var CodeInsertIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M27.5344 7.74143C27.6774 7.20796 28.2257 6.89138 28.7592 7.03432C29.2926 7.17726 29.6092 7.7256 29.4663 8.25907L20.6816 41.0439C20.5387 41.5774 19.9903 41.8939 19.4569 41.751C18.9234 41.6081 18.6068 41.0597 18.7498 40.5263L27.5344 7.74143Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M2.35737 25.6046C1.88101 24.9417 1.87984 24.0413 2.36007 23.3774L2.37417 23.3579L11.5523 11.8758C11.8971 11.4444 12.5264 11.3742 12.9578 11.7191C13.3892 12.0639 13.4593 12.6932 13.1145 13.1246L4.02734 24.4929L13.1149 35.8765C13.4595 36.3081 13.3889 36.9373 12.9573 37.2819C12.5257 37.6264 11.8964 37.5559 11.5519 37.1242L2.37214 25.6252L2.35737 25.6046Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M45.643 25.6046C46.1193 24.9417 46.1205 24.0413 45.6403 23.3774L45.6262 23.3579L36.4481 11.8758C36.1032 11.4444 35.4739 11.3742 35.0425 11.7191C34.6111 12.0639 34.541 12.6932 34.8858 13.1246L43.973 24.4929L34.8854 35.8765C34.5409 36.3081 34.6114 36.9373 35.043 37.2819C35.4747 37.6264 36.1039 37.5559 36.4484 37.1242L45.6282 25.6252L45.643 25.6046Z"
  }));
});
CodeInsertIcon.displayName = 'CodeInsertIcon';
CodeInsertIcon.defaultProps = {
  'aria-label': 'CodeInsert'
};
export default CodeInsertIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/CodeInsertIcon/index.js
// module id = 1809
// module chunks = 12